import { __extends } from "tslib";
import { DeleteStreamInput } from "../models/models_0";
import { deserializeAws_json1_1DeleteStreamCommand, serializeAws_json1_1DeleteStreamCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteStreamCommand = /** @class */ (function (_super) {
    __extends(DeleteStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KinesisClient";
        var commandName = "DeleteStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: DeleteStreamInput.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DeleteStreamCommand(input, context);
    };
    DeleteStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DeleteStreamCommand(output, context);
    };
    return DeleteStreamCommand;
}($Command));
export { DeleteStreamCommand };
//# sourceMappingURL=DeleteStreamCommand.js.map